module.exports = __webpack_public_path__ + "img/vpower.27b8c052.png";